import React from 'react';
import { X } from 'lucide-react';

const PrivacyPolicy = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="relative bg-surface-card rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-6 border border-border">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-2 text-ink-tertiary hover:text-ink rounded-lg hover:bg-hover transition-colors z-10"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-xl font-bold mb-4 text-center pr-8 text-ink">Privacy Policy</h2>
        
        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Information We Collect</h3>
        <p className="text-sm mb-4 text-ink-secondary">We collect minimal, non-identifiable information to enhance your experience and improve our Service. The types of information we may collect include:</p>
        <ul className="list-disc list-inside mb-4">
          <li className="text-sm text-ink-secondary">Usage Data: Information about how you interact with our Service, such as pages visited and features used.</li>
          <li className="text-sm text-ink-secondary">Technical Data: Non-identifiable data like your IP address, browser type, operating system, and device information.</li>
        </ul>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">How We Use Your Information</h3>
        <p className="text-sm mb-4 text-ink-secondary">We use the collected information for the following purposes:</p>
        <ul className="list-disc list-inside mb-4">
          <li className="text-sm text-ink-secondary">To operate and maintain our Service.</li>
          <li className="text-sm text-ink-secondary">To improve user experience and functionality.</li>
          <li className="text-sm text-ink-secondary">To analyze usage patterns to enhance our Service.</li>
        </ul>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Legal Basis for Processing (For EU Users)</h3>
        <p className="text-sm mb-4 text-ink-secondary">Under the General Data Protection Regulation (GDPR), our legal bases for processing your information are:</p>
        <p className="text-sm mb-4 text-ink-secondary">Legitimate Interests: We process non-identifiable information to improve our Service.</p>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Cookies and Similar Technologies</h3>
        <p className="text-sm mb-4 text-ink-secondary">We may use cookies and similar tracking technologies to collect and store information. Cookies are small data files placed on your device. You can instruct your browser to refuse all cookies or indicate when a cookie is being sent.</p>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Data Retention</h3>
        <p className="text-sm mb-4 text-ink-secondary">We retain collected information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.</p>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Data Security</h3>
        <p className="text-sm mb-4 text-ink-secondary">We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction.</p>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Your Rights</h3>
        <p className="text-sm mb-2 text-ink font-medium">EU/EEA Residents</p>
        <p className="text-sm mb-4 text-ink-secondary">Under the GDPR, you have the following rights:</p>
        <ul className="list-disc list-inside mb-4">
          <li className="text-sm text-ink-secondary">Access: Request access to your personal data.</li>
          <li className="text-sm text-ink-secondary">Rectification: Request correction of any inaccurate data.</li>
          <li className="text-sm text-ink-secondary">Erasure: Request deletion of your personal data.</li>
          <li className="text-sm text-ink-secondary">Restriction: Request restriction of processing your data.</li>
          <li className="text-sm text-ink-secondary">Objection: Object to processing based on legitimate interests.</li>
          <li className="text-sm text-ink-secondary">Data Portability: Request transfer of your data to you or a third party.</li>
        </ul>
        <p className="text-sm mb-2 text-ink font-medium">California Residents</p>
        <p className="text-sm mb-4 text-ink-secondary">Under the California Consumer Privacy Act (CCPA), you have the right to:</p>
        <ul className="list-disc list-inside mb-4">
          <li className="text-sm text-ink-secondary">Know: Request disclosure of the categories and specific pieces of personal information collected.</li>
          <li className="text-sm text-ink-secondary">Delete: Request deletion of personal information we have collected.</li>
          <li className="text-sm text-ink-secondary">Non-Discrimination: Not be discriminated against for exercising your privacy rights.</li>
        </ul>
        <p className="text-sm mb-4 text-ink-secondary">Note: Since we do not collect personal information that identifies you individually, certain rights may not be applicable.</p>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Children's Privacy</h3>
        <p className="text-sm mb-4 text-ink-secondary">Our Service is not intended for individuals under the age of 16. We do not knowingly collect personal information from children.</p>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">International Data Transfers</h3>
        <p className="text-sm mb-4 text-ink-secondary">Your information may be transferred to and processed in countries other than your country of residence. We ensure that appropriate safeguards are in place to protect your data.</p>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Changes to This Privacy Policy</h3>
        <p className="text-sm mb-4 text-ink-secondary">We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.</p>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Trademark Disclaimer</h3>
        <p className="text-sm mb-4 text-ink-secondary">
          All names, brand names, logos, and trademarks used on this website are the property of their respective owners. We do not claim any rights, title, or interest in or to any of these trademarks.
        </p>

        <h3 className="text-sm font-semibold mt-4 mb-1 text-ink">Contact Us</h3>
        <p className="text-sm mb-4 text-ink-secondary">If you have any questions or concerns about these policies or our data practices, please contact us:</p>
        <p className="text-sm text-ink-secondary">CONFORM.TOOLS LLC</p>
        <p className="text-sm text-ink-secondary">2815 Manor Rd, Ste 202</p>
        <p className="text-sm text-ink-secondary">Austin, TX 78722 USA</p>
        <p className="text-sm text-ink-secondary"><a href="mailto:datacalc@conform.tools" className="text-conform-red hover:text-conform-red-accent transition-colors">support@conform.tools</a></p>

        <button
          onClick={onClose}
          className="mt-6 bg-conform-red-deep hover:bg-conform-red-accent text-white font-medium py-2.5 px-6 rounded-lg mx-auto block md:block hidden transition-colors">
          Close
        </button>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
